module.exports = new __parcel__URL__("lightningfire.469d20f6.png").toString();